// mobile-nav.ts

/**
 * Shows menu, and closes menu on link click.
 * Toggles the 'open' class on the trigger and mobile nav elements.
 */
function mobileNav(): void {
	document.querySelector<HTMLElement>('.js-trigger-nav')
      ?.addEventListener('click', function () {
        this.classList.toggle('open');
        document.querySelector<HTMLElement>('.js-mobile-nav, .branding')?.classList.toggle('open');
        document.body?.classList.toggle('no-scroll');
      });

    document.querySelectorAll<HTMLElement>('.js-mobile-nav a')
      .forEach((link) => {
        link.addEventListener('click', function () {
          document.querySelector<HTMLElement>('.js-trigger-nav')?.classList.remove('open');
          document.querySelector<HTMLElement>('.js-mobile-nav, .branding')?.classList.remove('open');
          document.body?.classList.remove('no-scroll');
        });
      }
    );
}

export { mobileNav };  